
<!--Main Layout-->
<main class="background-preview animated fadeIn fast">
    <div class="main-view">
        <mdb-breadcrumb customClass="white" class="breadcrumbs mt-3 mb-0 pb-0">
            <mdb-breadcrumb-item routerLink="/backrep/home" class="breadcrumbs-disabled"><i class="fa-solid fa-house mr-1"></i>Backoffice</mdb-breadcrumb-item>
            <mdb-breadcrumb-item class="active" class="breadcrumbs-enabled">Usuarios</mdb-breadcrumb-item>
        </mdb-breadcrumb>
        <div class="container">
            <div class="icon-preview pb-3">
                <img src="/assets/usersback.svg" width="75px" alt="image">
                <h1 class="text-center title-view pl-3 mx-0">Usuarios</h1>
            </div>
            <div class="table-div mt-2 pb-3 z-depth-5">
                <div class="table-header">
                    <div style="width: 45px; height: 45px;"></div>
                    <h2 class="title-header">Registro de Usuarios</h2>
                    <button mdbBtn type="button" class="button-add" (click)="showAddUser()" mdbWavesEffect>
                        <mdb-icon fas icon="plus-circle" floating="true" size="2x"></mdb-icon>
                      </button>
                </div>
                <div class="table-body container">
                    <app-table [data]="users" [stateModal]="stateModal" [headElements]="headElements" [headTable]="headTable" [colspanLarge]="colspanLarge"
                     (reponseStateModal)="onReponseStateModal($event)"
                     (reponseDeleteTable)="onreponsDeleteObjectTable($event)"
                     (reponseUpdateTable)="onreponseUpdateObjectTable($event)"></app-table>
                </div>
            </div>
        </div>

    </div>
</main>

<app-modal-accept [modalInfo]="modalInfo" [stateModal]="stateModalAlert"
    (reponseStateModalAccept)="onResponseModalAlert($event)"
    (reponsDeleteObjectAlert)="onReponseDeleteObjectAlert($event)">
</app-modal-accept>

<div mdbModal #modalAddUser="mdbModal" class="modal fade right" id="modalAddUser" tabindex="-1" role="dialog"
aria-labelledby="myModalLabel" aria-hidden="true" [config]="{backdrop: true, ignoreBackdropClick: true}">
<div class="modal-dialog modalUser" role="document">
    <div class="modal-content">
        <div class="modal-header head-modals">
            <h2 class="modal-title w-100 title-modals" id="myModalLabel">Agregar Usuario
            </h2>
            <button type="button" class="close x-modals" data-dismiss="modal" aria-label="Close"
                (click)="modalAddUser.hide()">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body modals-body container">
            <form class="form-horizontal p-t-20 text-modals" [formGroup]="userForm" (submit)="submitUser()">

                 <div class="row">
                    <div class="col-4 md-form md-outline">
                        <input id="form-lg" formControlName="name1" id="name1" class="form-control" type="text" mdbInput>
                        <label for="form-lg" class="pl-4">Primer Nombre</label>
                        <mdb-error *ngIf="name1.invalid && (name1.dirty || name1.touched)" style="color: red;" class="pl-3">Nombre ingresado no es valido</mdb-error>
                        <mdb-success *ngIf="name1.valid && (name1.dirty || name1.touched)" style="color: green;" class="pl-3">Nombre ingresado es valido</mdb-success>
                    </div>
                    <div class="col-4 md-form md-outline">
                        <input id="form-lg" formControlName="last_name1" id="last_name1" class="form-control" type="text" mdbInput>
                        <label for="form-lg"  class="pl-4">Apellido Paterno</label>
                        <mdb-error *ngIf="last_name1.invalid && (last_name1.dirty || last_name1.touched)" style="color: red;" class="pl-3">Apellido ingresado no es valido</mdb-error>
                        <mdb-success *ngIf="last_name1.valid && (last_name1.dirty || last_name1.touched)" style="color: green;" class="pl-3">Apellido ingresado es valido</mdb-success>
                    </div>
                    <div class="col-4 md-form md-outline">
                        <input id="form-lg" formControlName="last_name2" id="last_name2" class="form-control" type="text" mdbInput>
                        <label for="form-lg" class="pl-4">Apellido Materno</label>
                        <mdb-error *ngIf="last_name2.invalid && (last_name2.dirty || last_name2.touched)" style="color: red;" class="pl-3">Apellido ingresado no es valido</mdb-error>
                        <mdb-success *ngIf="last_name2.valid && (last_name2.dirty || last_name2.touched)" style="color: green;" class="pl-3">Apellido ingresado es valido</mdb-success>
                    </div>
                    <!-- <div class="col-4 md-form md-outline">
                        <input id="form-lg" formControlName="company" id="company" class="form-control" type="text" mdbInput>
                        <label for="form-lg" class="pl-4">Compañia</label>
                    </div> -->

                    <div class="col-4 md-form md-outline">
                        <mdb-select-2 [outline]="true" placeholder="Seleccionar Compañia" label="Compañia" [formControlName]="'company'">
                            <mdb-select-option *ngFor="let option of companies" [value]="option.uid">{{ option.name }}</mdb-select-option>
                        </mdb-select-2>
                    </div>
                    <div class="col-4 md-form md-outline">
                        <input id="form-lg" formControlName="email" id="email" class="form-control" type="text" mdbInput>
                        <label for="form-lg" class="pl-4">Email</label>
                        <mdb-error *ngIf="email.invalid && (email.dirty || email.touched)" style="color: red;" class="pl-3">Email ingresado no es valido</mdb-error>
                        <mdb-success *ngIf="email.valid && (email.dirty || email.touched)" style="color: green;" class="pl-3">Email ingresado es valido</mdb-success>
                    </div>
                   <div class="col-4 md-form md-outline">
                        <mdb-select-2 [outline]="true" placeholder="Seleccionar Rol" label="Rol" [formControlName]="'role'">
                            <mdb-select-option *ngFor="let option of options" [value]="option.value">{{ option.label }}</mdb-select-option>
                        </mdb-select-2>
                        <!-- <mdb-select [outline]="true" [options]="options" formControlName="role" name="role" placeholder="Choose your option"></mdb-select> -->
                    </div>
                    <div class="col-4 md-form md-outline">
                        <mdb-select-2 [outline]="true" placeholder="Seleccionar Estado" label="Estado" [formControlName]="'active'">
                            <mdb-select-option *ngFor="let option of states" [value]="option.value">{{ option.label }}</mdb-select-option>
                        </mdb-select-2>
                    </div>
                </div> 



                <div class="modal-footer modals-footer pt-3">
                    <button type="button" mdbBtn class="bwaves-light button-cancel-modals" data-dismiss="modal"
                        (click)="modalAddUser.hide()" mdbWavesEffect>Cancelar</button>
                    <button type="submit" mdbBtn class="waves-light button-accept-modals"
                        mdbWavesEffect>Aceptar</button>
                </div>
            </form>


        </div>
    </div>
</div>
</div> 

<ngx-spinner bdColor = "rgba(3,128,128,0.7)" size = "medium" color = "#fff" type = "ball-spin-clockwise" [fullScreen] = "true"><p style="color: white" > Cargando... </p></ngx-spinner>
